import { JsonObject, JsonProperty } from 'json2typescript';
import { CollectionBoosterDrop } from './collection-booster-drop.model';
import { CollectionCardRankType } from '../../enums/collections/collection-card-rank-type.enum';

@JsonObject('CollectionBooster')
export class CollectionBooster {

  @JsonProperty('booster_rank_type', Number)
  boosterRankType: CollectionCardRankType = CollectionCardRankType.None;

  @JsonProperty('cards_drop_count', Number)
  cardsDropCount: number = 0;

  @JsonProperty('drops', [CollectionBoosterDrop])
  drops: CollectionBoosterDrop[] = [];
}
